import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GlobalsService} from './globals.service';

@Injectable({
  providedIn: 'root'
})
export abstract class Crud {
  serverRoot: string;

  constructor(protected http: HttpClient, private globalsservice: GlobalsService) {
    this.serverRoot = this.globalsservice.getBffapiroot();
  }

  abstract createEntity(entityjson: {}): Observable<any>;

  abstract getEntity(entityjson: string): Observable<any>;

  abstract getEntities(): Observable<any>;

  abstract updateEntity(id: string, entityjson: {}): Observable<any>;

  abstract removeEntity(entityid: string): Observable<any>;
}
